import Login from '../../components/Login/Login';

const SignUp = () => {
  return (
    <div className="min-h-screen bg-background">
      <Login />
    </div>
  );
};

export default SignUp;
